import React from 'react'
import RulesEN from './RulesEN'
import RulesPT from './RulesPT'
import RulesRU from './RulesRU'
import RulesZH from './RulesZH'
import RulesID from './RulesID'
import RulesVN from './RulesVN'
import BackLink from '../ui/buttons/BackLink'
import { Helmet } from "react-helmet"

const content = (event) => {
  let html;
  const locale = I18n.locale;

  switch(window.COUNTRY) {
    case 'RU':
      I18n.locale = 'ru';
      html = RulesRU(event);
      break;
    case 'CN':
      html = RulesZH;
      break;
    case 'BR':
      I18n.locale = 'pt';
      html = RulesPT(event);
      break;
    case 'ID':
      I18n.locale = 'ind';
      html = RulesID(event);
      break;
    case 'VN':
      I18n.locale = 'vi';
      html = RulesVN(event);
      break;
    default:
      I18n.locale = 'en';
      html = RulesEN(event);
  }

  I18n.locale = locale;
  return { __html: html };
}

const title = () => {
  return "DinoMath Olympiad: Guide for Students, Parents, and Teachers"
}

const Rules = ({ global: { event } }) => {

  return (
    <div className="static">
      <Helmet>
        <title>{ title() }</title>
      </Helmet>
      <BackLink />
      <div dangerouslySetInnerHTML={ content(event) } />
    </div>
  )
}

export default Rules
